export const faqs = [
  {
    q: '"缅北黑料"里的内容都是真实发生的吗？',
    a: '档案中的每一篇内容都来自公开报道、办案通报或经当事人授权的讲述，并对姓名、地点、时间做了匿名与模糊化处理。我们只保留可用于识别骗局的关键特征，不公布任何真实个人身份信息。',
  },
  {
    q: '看到"高薪出国工作、包吃包住包机票"，应该怎么判断？',
    a: '先看两样东西：正规的境外工作签证，以及写明岗位、薪资与合同期限的书面劳动合同。两者缺一，或对方以"落地再签"为由推脱，就应当立即停止沟通，不要再提供护照照片和身份信息。',
  },
  {
    q: '家人已经出境并失去联系，第一步该做什么？',
    a: '先固定证据：保存聊天记录、转账凭据、对方账号、出境时间与口岸，然后向户籍地公安机关报案登记，同时联系中国驻当地使领馆寻求协助。切勿轻信网上"付费捞人"的中介，这本身也是常见的二次诈骗。',
  },
  {
    q: '为什么很多骗局都从"感情"开始？',
    a: '情感铺垫能显著降低防备心。所谓杀猪盘正是用数周到数月的陪伴建立信任，再以"内部渠道""跟着老师操作"为名诱导投资。凡是先谈感情、后谈赚钱的关系，都需要保持警惕。',
  },
  {
    q: '虚假投资平台为什么一开始能顺利提现？',
    a: '这是典型的"养熟"阶段。平台会先让你小额获利并顺利提现，制造真实感，等你加大投入后，再以"需要缴税""账户异常""流水不足"等理由冻结资金。小额能提，恰恰是风险信号，而不是安全证明。',
  },
  {
    q: '接到境外号码的招聘或客服电话，要不要直接挂断？',
    a: '对陌生境外号码主动来电、且涉及招聘、贷款、退款、投资的内容，建议直接挂断。正规企业的招聘不会通过私人境外号码反复催促你尽快决定，更不会要求你先行转账。',
  },
  {
    q: '网站内容可以转载用于反诈宣传吗？',
    a: '可以。公益性质的反诈宣讲、社区宣传与校园科普均可非商业转载，注明来源即可。商业用途请先通过联系表单与我们沟通，避免内容被断章取义。',
  },
  {
    q: '提交线索后，我的个人信息会被公开吗？',
    a: '不会。所有线索默认匿名处理，仅在核实过程中内部查阅。若你不希望留下任何联系方式，可以只填写事件经过，我们同样会认真归档。',
  },
];